import { createSlice } from "@reduxjs/toolkit";

const MAX_LIVE_ITEMS = 50;

const initialState = {
  liveItems: [],
  unreadCount: 0,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    addLiveNotification(state, action) {
      state.liveItems = [action.payload, ...state.liveItems].slice(
        0,
        MAX_LIVE_ITEMS
      );
      state.unreadCount += 1;

      return state;
    },
    setUnreadCount(state, action) {
      state.unreadCount = action.payload || 0;

      return state;
    },
    markLiveItemRead(state, action) {
      state.liveItems = state.liveItems.map((item) =>
        item._id === action.payload ? { ...item, isRead: true } : item
      );

      return state;
    },
    decrementUnread(state) {
      state.unreadCount = Math.max(0, state.unreadCount - 1);

      return state;
    },
    removeLiveItem(state, action) {
      state.liveItems = state.liveItems.filter((item) => item._id !== action.payload);

      return state;
    },
    resetNotifications() {
      return initialState;
    },
  },
});

export const notificationsActions = notificationsSlice.actions;

export default notificationsSlice.reducer;
